import { useInfiniteQuery, type InfiniteData } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import type {
  TGetListaDeImobiliariasCorretoresParams,
  TGetListaDeImobiliariasCorretoresResponse,
} from '@/features/proposta/interfaces/imobiliarias.types'
import { GetListarImobiliariasCorretoresService } from '@/features/proposta/services'
import { propostaKeys } from '@/features/proposta/utils'

export const useListarImobiliariasCorretores = (query: Partial<TGetListaDeImobiliariasCorretoresParams>) =>
  useInfiniteQuery<
    TGetListaDeImobiliariasCorretoresResponse,
    AxiosError,
    InfiniteData<TGetListaDeImobiliariasCorretoresResponse>,
    ReturnType<typeof propostaKeys.listaImobiliariasCorretores>,
    number
  >({
    retry: false,
    queryKey: propostaKeys.listaImobiliariasCorretores(query),
    queryFn: ({ pageParam }) =>
      new GetListarImobiliariasCorretoresService()
        .execute({ paginaCorrente: pageParam, ...query })
        .then((res) => res.data),
    initialPageParam: 1,
    getNextPageParam: ({ metadata: { paginaCorrente, totalDePaginas } }, todasPaginas) =>
      totalDePaginas > paginaCorrente ? todasPaginas.length + 1 : undefined,
    staleTime: 5 * 60 * 1000, // 5 minutos
  })
